import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormTextField from "components/form/form-textfield";
import FormImageSize from "components/form/form-image-size";
import PosWarning from "components/form/form-image-pos/pos-warning";
import isEqual from "lodash/isEqual";
import { MAX_POS_X, MAX_POS_Y } from "../default-values";

const getProps = props => ({
    ...props,
    layout: {
        pos: { ...props.layout.pos },
        size: { ...props.layout.size },
        originalSize: { ...props.layout.originalSize },
    },
});

const calculateMaxPos = layout => ({
    maxX: MAX_POS_X - Number(layout.size.x),
    maxY: MAX_POS_Y - Number(layout.size.y),
    isXPosCorrect: Number(layout.pos.x) <= MAX_POS_X - Number(layout.size.x),
    isYPosCorrect: Number(layout.pos.y) <= MAX_POS_Y - Number(layout.size.y),
});

const LayoutPosAndSizeForm = ({ originalSize, layoutPath, layout, handleChange, intl }) => {
    const handleFocus = event => event.target.select();

    const { isXPosCorrect, isYPosCorrect, maxX, maxY } = calculateMaxPos(layout);

    return (
        <>
            <DataGridItem big>
                <DataGrid withPadding={false}>
                    <DataGridItem>
                        <FormTextField
                            marginDense
                            type="number"
                            id={`${layoutPath}.pos.x`}
                            name={`${layoutPath}.pos.x`}
                            onChange={handleChange}
                            label={intl.formatMessage({ id: "graphicset.layout.pos.x" })}
                            value={layout.pos.x}
                            onFocus={handleFocus}
                        />
                    </DataGridItem>
                    <DataGridItem>
                        <FormTextField
                            marginDense
                            type="number"
                            id={`${layoutPath}.pos.y`}
                            name={`${layoutPath}.pos.y`}
                            onChange={handleChange}
                            label={intl.formatMessage({ id: "graphicset.layout.pos.y" })}
                            value={layout.pos.y}
                            onFocus={handleFocus}
                        />
                    </DataGridItem>
                </DataGrid>
                {(!isXPosCorrect || !isYPosCorrect) && <PosWarning maxX={maxX} maxY={maxY} />}
            </DataGridItem>
            <DataGridItem big>
                <FormImageSize
                    marginDense
                    id={`${layoutPath}.size`}
                    name={`${layoutPath}.size`}
                    onChange={handleChange}
                    label={{
                        x: intl.formatMessage({ id: "graphicset.layout.size.x" }),
                        y: intl.formatMessage({ id: "graphicset.layout.size.y" }),
                        maintainAspectRatio: intl.formatMessage({ id: "common.form.maintainAspectRatio" }),
                    }}
                    value={layout.size}
                    originalSize={layout.originalSize}
                />
            </DataGridItem>
        </>
    );
};

LayoutPosAndSizeForm.propTypes = {
    layoutPath: PropTypes.string,
    handleChange: PropTypes.func,
    layout: PropTypes.object,
    originalSize: PropTypes.object,
};

export default React.memo(injectIntl(LayoutPosAndSizeForm), (prevProps, nextProps) => {
    return isEqual(getProps(prevProps), getProps(nextProps));
});
